import {EventEmitter, Injectable, Output} from '@angular/core';
import {MainPageDetailInterface} from 'src/app/interfaces/plans.interface';
import {StateInterface} from 'src/app/interfaces/state.interface';
import {environment} from 'src/environments/environment';

@Injectable()

export class EventsManager {
  @Output() public showHideSubheader: EventEmitter<boolean> = new EventEmitter();
  @Output() public officeUpdate: EventEmitter<any> = new EventEmitter();
  @Output() public planDetailUpdate: EventEmitter<any> = new EventEmitter();
  @Output() public levelSelected: EventEmitter<any> = new EventEmitter();
  @Output() public feeScheduleUpdate: EventEmitter<any> = new EventEmitter();
  @Output() public showPaymentScreen: EventEmitter<any> = new EventEmitter();
  @Output() public showSuccessScreen: EventEmitter<any> = new EventEmitter();
  @Output() public togglePrimary: EventEmitter<any> = new EventEmitter();
  @Output() public sendSuccessfulPayment: EventEmitter<any> = new EventEmitter();
  @Output() public sendPaymentError: EventEmitter<any> = new EventEmitter();
  @Output() public sendPaymentTimeout: EventEmitter<any> = new EventEmitter();
  @Output() public acceptMemberAgreement: EventEmitter<any> = new EventEmitter();
  @Output() public setPurchaseStep: EventEmitter<any> = new EventEmitter();
  @Output() public loadingState: EventEmitter<any> = new EventEmitter();
  @Output() public getwWhoIsPrimary: EventEmitter<any> = new EventEmitter();
  @Output() public memberCountUpdate: EventEmitter<any> = new EventEmitter();
  @Output() public updateForm: EventEmitter<any> = new EventEmitter();
  @Output() public taxPercUpdated: EventEmitter<any> = new EventEmitter();
  @Output() public statesLoaded: EventEmitter<any> = new EventEmitter();
  @Output() public getPlanOptions: EventEmitter<any> = new EventEmitter();
  @Output() public contactInfoUpdated: EventEmitter<any> = new EventEmitter();
  @Output() public homePageDetailUpdated: EventEmitter<string> = new EventEmitter();
  @Output() public isAdminByUpdated: EventEmitter<string> = new EventEmitter();
  @Output() public planDataUpdated: EventEmitter<string> = new EventEmitter();
  @Output() public hideHeader: EventEmitter<boolean> = new EventEmitter();

  public orgId: string = '';
  public officeInfo?: MainPageDetailInterface = undefined;
  public planDetailInfo: any = {};
  public selectedLevel: any = {};
  public showLoading: boolean = false;
  public legalLanguage: any = {};
  public isLocationConfirmPage: boolean = false;
  public isLocationOff: boolean = false;
  public states: StateInterface[] = [];
  public selectedState: StateInterface = {name:'', value:'', abbr:''};
  public planOptions: any = {};
  public isAdminBy: string = 'wellfit';
  public contactInfo: any ={};
  public planId: string = '';
  public homePageDetails: any = {};
  public planEmail: string = environment.planEmail;
  public planName: string = 'Smile Generation Dental Plan';
  public planYear: string = '';
  public allowedStates: any = {};
  public hideTopHeader: boolean = false;
  public purchaseIsADHA: boolean = false;
  public adhaPractice: string = '1D550000-FFFF-000D-889B-08D43C1753AA';

  public getOfficeInfo() {
    let office: any = {};
    if (this.officeInfo?.name) {
      office = this.officeInfo;
    } else if (sessionStorage['office']) {
      office = JSON.parse(sessionStorage['office']);
      this.officeInfo = office;
    }

    return office;
  }

  public setPlanDetails(details: any) {
    sessionStorage['planDetails'] = JSON.stringify(details);
    this.planDetailInfo = details;
    this.planDetailUpdate.emit();
  }

  public setLevelSelected(level: any) {
    sessionStorage['level'] = JSON.stringify(level);
    this.selectedLevel = level;
    this.levelSelected.emit();
  }

  public setLoadingState(state: boolean) {
    this.showLoading = state;
    this.loadingState.emit(this.showLoading);
  }

  public setStates(states: StateInterface[]) {
    this.states = states;
    this.statesLoaded.emit();
  }

  public setIsAdminBy(isAdminBy: string) {
    this.isAdminBy = isAdminBy;
    if (isAdminBy == null) {
      this.isAdminBy = 'wellfit';
    }
    this.isAdminByUpdated.emit(this.isAdminBy);
  }

  public setHideHeader(hide: boolean) {
    this.hideTopHeader = hide;
    this.hideHeader.emit(this.hideTopHeader);
  }

  public lookUpState(name: string) {
    let found: StateInterface = {name:'', value:'', abbr:''};
    for (let i: number = 0;i<this.states.length;i++) {
      if (this.states[i].abbr === name) {
        found = this.states[i];
        break;
      }
    }
    return found;
  }

  public isStateAllowed(state: string): boolean {
    let found: boolean = false;
    for (let s: number = 0;s<this.allowedStates.length;s++) {
      if (this.allowedStates[s].abbr === state) {
        found = true;
        break;
      }
    }
    return found;
  }
}
